import StartScreen from './StartScreen';

export default StartScreen;
